import { ConfiguratorConfig, ConfigurationsRegistry } from '@icc/configurator/types';
import { AwningActiveConfiguration } from './awning-active-configuration';
import { AwningConfiguration } from './awning-configuration';

export const AWNING_CONFIGURATOR_CONFIG: ConfiguratorConfig = {
    type: 'awning',
    activeConfigurationClass: AwningActiveConfiguration,
    configurationClass: AwningConfiguration
};

export function registerAwningConfigurations(): void {
    ConfigurationsRegistry.register(AWNING_CONFIGURATOR_CONFIG);
}
